











































































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import ContractDappCellRender from '@/components/render/ContractDappCellRender.vue'
import TooltipInfoButton from '@/components/TooltipInfoButton.vue'
import {EnvHelper} from '@/helpers/EnvHelper'
import {OrbitRoundRewardCollection} from '@/model/collection/OrbitRoundRewardCollection'
import {OrbitRoundReward} from '@/model/resource/OrbitRoundReward'
import {TextHelper} from '@/helpers/TextHelper'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {OrbitProject} from '@/model/resource/OrbitProject'

@Component({
  components: {
    ContractDappCellRender,
    TooltipInfoButton,
  },
})
export default class MyWalletOrbitScrollableTable extends Vue {
  @Prop({type: OrbitRoundRewardCollection, required: true})
  orbitRewardCollection!: OrbitRoundRewardCollection
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection
  @Prop({type: Number, required: true}) currentRound!: number
  @Prop({type: Number, required: true}) activeRound!: number
  @Prop({type: Object, required: true}) transactionCountMap!: Record<
    number,
    {
      total: string
      your: string
    }
  >

  get isActiveRound() {
    return this.currentRound === this.activeRound
  }

  oneGateLink(hash: string) {
    return `${EnvHelper.ONE_GATE_URL}contractinfo/${hash}`
  }

  getYourTxs(item: OrbitProject): string {
    if (!item.idOrbitProjectPk) return '0'
    return String(this.transactionCountMap[item.idOrbitProjectPk]?.your ?? '0')
  }

  getTotalTxs(item: OrbitProject): string {
    if (!item.idOrbitProjectPk) return '0'
    return String(this.transactionCountMap[item.idOrbitProjectPk]?.total ?? '0')
  }

  getRewardForProject(project: OrbitProject): OrbitRoundReward | null {
    if (!project.idOrbitProjectPk) return null
    return (
      this.orbitRewardCollection.items.find(
        reward =>
          reward.orbitProject?.idOrbitProjectPk === project.idOrbitProjectPk
      ) || null
    )
  }

  getRewardAmount(item: OrbitProject): string {
    const reward = this.getRewardForProject(item)
    if (!reward) return '0'
    const status = reward.status
    const isDistributedToOthers =
      !!status &&
      status !== 'distributed_to_others' &&
      status.endsWith('_distributed_to_others')
    if (
      status !== 'approved' &&
      status !== 'claimed' &&
      status !== 'expired' &&
      !isDistributedToOthers &&
      status !== 'distributed_to_others'
    )
      return '0'
    if (reward.amount == null || !reward.tokenPriced?.decimals) return 'N/A'

    const decimals = Number(reward.tokenPriced.decimals)
    const amount = Number(reward.amount) / Math.pow(10, decimals)

    const amountFormatted = TextHelper.formatAmount(amount)

    if (status === 'expired') {
      return `${amountFormatted} (expired)`
    }

    if (
      status === 'distributed_to_others' ||
      (status && status.endsWith('_distributed_to_others'))
    ) {
      return `${amountFormatted} (${this.$translate(
        'components.MyWalletOrbitScrollableTable.rewardDistributedToOthersSuffix'
      )})`
    }

    return amountFormatted
  }

  getRewardAmountUSD(item: OrbitProject): string {
    const reward = this.getRewardForProject(item)
    if (!reward) return 'US$ 0.00'
    if (reward.status !== 'approved' && reward.status !== 'claimed')
      return 'US$ 0.00'
    if (
      reward.amount == null ||
      !reward.tokenPriced?.decimals ||
      !reward.tokenPriced?.lastPriceStored
    ) {
      return 'N/A'
    }

    const decimals = Number(reward.tokenPriced.decimals)
    const amount = Number(reward.amount) / Math.pow(10, decimals)
    const tokenPrice = Number(reward.tokenPriced.lastPriceStored)
    const rewardUSD = amount * tokenPrice

    return `US$ ${rewardUSD.toFixed(2)}`
  }

  isRewardExpired(reward: OrbitRoundReward): boolean {
    if (reward.status === 'expired') return true
    const roundCreatedAt = reward.orbitRound?.createdAt
    if (!roundCreatedAt) return false
    const roundStartMs = new Date(roundCreatedAt as any).getTime()
    if (isNaN(roundStartMs)) return false
    const expiresAtMs = roundStartMs + 7 * 24 * 60 * 60 * 1000
    return expiresAtMs <= Date.now()
  }
}
